import { PopupAuthenticator } from '@ms/yammer-web-authenticators';
import { useCallback } from 'react';

import config from '../../bootstrap/config';

type UseLoginCallback = (authenticator: PopupAuthenticator) => () => void;
export const useLoginCallback: UseLoginCallback = (authenticator) =>
  useCallback(async () => {
    await authenticator.loginPopup([config.adal.resources.yammer]);
  }, [authenticator]);
